import { TravelerForGroup } from '../objects/travelerForGroup';

export const ADULT_TRAVELER_FOR_GROUP: TravelerForGroup = {
    id: 0,
    first_name: 'shared.traveler',
    last_name: 'shared.adult',
    birth_date: 30,
    room_id:0,
    error: ''
};

export const CHILD_TRAVELER_FOR_GROUP: TravelerForGroup = {
    id: 0,
    first_name: 'shared.traveler',
    last_name: 'shared.child',
    birth_date: 5,
    room_id:0,
    error: ''
};

export const EMPTY_TRAVELER_GROUP: TravelerForGroup[][] = [[ADULT_TRAVELER_FOR_GROUP]];
